import React from 'react';
import PageHeader from './PageHeader';
import AppSidebar from './AppSidebar';

const LogsTable = ({ allCallLogs }) => {

  return (
    <>
      <AppSidebar />
      <div className="row justify-content-center">
        <div className="col-12">
          <PageHeader title="Call Logs" />

          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="contactsListPane"
              role="tabpanel"
              aria-labelledby="contactsListTab"
            >
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-hover table-sm">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Type</th>
                        <th scope="col">Status</th>
                        <th scope="col">Feedback Type</th>
                        <th scope="col">Response</th>
                        <th scope="col">Reschedule</th>
                        <th scope="col">Remarks</th>
                        <th scope="col">Called By</th>
                      </tr>
                    </thead>
                    <tbody className="list fs-base">
                      {allCallLogs && Array.isArray(allCallLogs) && allCallLogs.length > 0 ? (
                        allCallLogs.map((row, index) => (
                          <tr key={row?.id}>
                            <td>{ index + 1}</td>
                            <td>{row?.type || 'Type not found'}</td>
                            <td>{row?.status || 'Status not found'}</td>
                            <td>{row?.feedback_type || 'Feedback type not found'}</td>
                            <td>{row?.response || 'Response not found'}</td>
                            <td>{row?.rescheduled_at || 'Reschedule date not found'}</td>
                            <td>{row?.remarks || 'Remarks not found'}</td>
                            <td>{row?.calledBy?.name || 'Calledby not found'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className='text-center'>No call logs available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogsTable;